export const setLocale = (locale: string) => ({ type: 'SET_LOCALE', locale });
